import { Routes, Route } from 'react-router-dom';
import { RoutesComponent, PublicComponent } from './routes/Routes';
import PrivateRoute from './routes/PrivateRoute';
import NotFoundPage from './pages/404/NotFoundPage';
import HomePublic from './pages/home/HomePublic';
import Login from './pages/auth/Login';
import moment from 'moment'
import { useEffect, useState } from 'react';
import envInstants from './configs/env';
import { setDefaultURL } from './api/api';
import Loading from './component/loading/Loading';
// import { logoutFunction } from './utils/logout';
import { useDispatch } from 'react-redux';
import { setLoading, unsetLoading } from './store/slice/loading/loading.slice';
 import { Authentication } from './api/auth/Authentication.api';
import { getToken, logout } from './utils/app.utils';
import { debounce } from 'lodash';



function App() {
  moment.locale('th')
  const dispatch = useDispatch();
  const token = getToken() || "";

  const [lastMouseMove, setLastMouseMove] = useState<number>(Date.now());
  const [isInitEnvError, setInitEnvError] = useState<boolean>(false);
  const [isInitEnv, setInitEnv] = useState<boolean>(false);

  useEffect(() => {
    const loadEnv = async () => {
      try {
        await envInstants.init();
        setDefaultURL(envInstants.getConfig().baseUrl);
      } catch (error) {
        setInitEnvError(true);
      } finally {
        setInitEnv(true);
      }
    };
    loadEnv();
  }, [])

  const logoutFunction = async () => {
    try {
      dispatch(setLoading());
      await Authentication.logout()
        .then((res) => {
          if (res.status === 200) {
            dispatch(unsetLoading());
            logout();
            window.location.href = '/login'
          }
        })
        .catch((error) => {
          dispatch(unsetLoading());
          throw new Error("Can't fetch api", error);
        });
    } catch (error) {
      console.log(error);
    }
  };
  // มีผลทำให้กด ที่ว่างแล้ว component rerender
  useEffect(() => {
    const interval = setInterval(() => {
      const currentTime = Date.now();
      const elapsedTime = currentTime - lastMouseMove;
      if (elapsedTime >= 60 * 60 * 1000) {
        if (token) {
          logoutFunction();
        }

      }
    }, 1000);
    return () => clearInterval(interval);
  }, [lastMouseMove]);

  const handleMouseMove = debounce(() => {
    setLastMouseMove(Date.now());
  }, 10000); 

  useEffect(() => {
    window.addEventListener('mousemove', handleMouseMove);
    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
    };
  }, []);

  if (!isInitEnv) return <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', height: "100vh" }}><Loading /></div>;
  if (isInitEnvError) return <div>"Cannot load env !!!"</div>;
  return (
    <>
      <Routes>
        {/* public route 👇 */}
        <Route index path='/' element={<Login />} />
        <Route path='/publish' element={<HomePublic />} />

        {PublicComponent.map((list) => (
          <Route
            key={list.key}
            path={list.path}
            element={<list.component />} />
        ))}

        {/* Private Route Zone 👇*/}
        <Route element={<PrivateRoute />}>
          {RoutesComponent.map((list) => {
            return (
              <Route
                key={list.key}
                path={list.path}
                element={<list.component />}
              />
            )
          })}
        </Route>

        {/* 404 PAGE 👇 */}
        <Route path='*' element={<NotFoundPage />} />

      </Routes>
    </>
  );
}

export default App;
